import script from "./FileItemPrivate.vue?vue&type=script&setup=true&lang=js"
export * from "./FileItemPrivate.vue?vue&type=script&setup=true&lang=js"

import "./FileItemPrivate.vue?vue&type=style&index=0&id=7886f114&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7886f114"]])

export default __exports__